import { render, staticRenderFns } from "./PaymentOrdersClaims.vue?vue&type=template&id=3127371a&"
import script from "./PaymentOrdersClaims.vue?vue&type=script&lang=js&"
export * from "./PaymentOrdersClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports